import { Component, ViewChild, NgZone, ChangeDetectorRef, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Loader } from '@loader/loader';
import { EnpsRouterComponent } from '@common/components/base/enps-router-component';

import { AppService } from '@suite/app.service';
import { ModalService } from '@common/components/modal/modal.service';

import { TimeoutQueue } from '@common/services/timeout-queue';
import { GlobalTablesService } from "@common/services/global-tables-service";
import { LanguageSettings } from "@common/services/language-settings";
import { NavigationService } from "@common/services/navigation-service";
import { AuthService } from '@common/services/authentication/auth.service';



@Component({
    template: '',
    styleUrls: ['./enps-single-page.scss']
})

export class EnpsSinglePageComponent extends EnpsRouterComponent {

    public isNew: boolean = false;

    constructor(
        public appService: AppService,
        protected modalService: ModalService,
        protected ngZone: NgZone,
        protected changeDetectorRef: ChangeDetectorRef,
        timeoutQueue: TimeoutQueue,
        authService: AuthService,
        protected activatedRoute: ActivatedRoute,
        public globalTablesService: GlobalTablesService,
        public navigationService: NavigationService,
        public languageSettings: LanguageSettings
    ) {
        super(timeoutQueue, authService, activatedRoute);
    }

    @ViewChild('loader') loader: Loader;
    @ViewChild('scrollContainer') scrollContainer: ElementRef;

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        if (this.authService.shouldReload) return;
    }

    public addNew() {
        this.isNew = true;
    }

    public cancelNew() {
        this.isNew = false;
    }
}
